import { Inject, Injectable } from '@angular/core';
import { USER_QUERIES, UserQueries } from '@/app/platform/platform-core/user/store/types';
import { PlatformUser } from '@/app/platform/platform-core/user/models/platform-user';

@Injectable({
  providedIn: 'root'
})
/**
 * The context for the current user
 */
export class PlatformUserContext {
  constructor(
    @Inject(USER_QUERIES)
    private readonly userQueries: UserQueries
  ) {}

  /**
   * The active(authenticated) user
   */
  readonly activeUser$ = this.userQueries.authenticatedUser$;

  /**
   * The active(authenticated) user
   */
  getActiveUser(): PlatformUser | undefined {
    return this.userQueries.getAuthenticatedUser();
  }

  getUserHasJustChanged(): boolean {
    return this.userQueries.getUserHasJustChanged();
  }
}
